<mat-card appearance="outlined" class="employee-multi-select-card me-0 ms-0 w-100">
  <mat-card-header>
    <mat-card-title>
      Selección de empleados
    </mat-card-title>
    <mat-card-subtitle>
      <span>
        <strong>{{ selectedIds.length }}</strong> empleados seleccionados
      </span>
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="search-actions-row">
      <app-input class="search-field" inputType="text" placeholder="Buscar empleado..." [formControl]="searchControl"></app-input>
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="selectAll()">Seleccionar todos</button>
        <button mat-stroked-button color="warn" (click)="clearAll()">Limpiar selección</button>
      </div>
    </div>

    <div class="empleados-lista mt-2">
      <div *ngFor="let empleado of pagedEmpleados; trackBy: trackByIndex" class="empleado-item">
        <mat-checkbox
          [checked]="selectedIds.includes(empleado.uid)"
          (change)="toggleEmpleado(empleado.uid)">
          {{ empleado.name }}
        </mat-checkbox>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions class="paginator-row">
    <mat-paginator
      [length]="filteredEmpleados.length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 20]"
      (page)="onPageChange($event)">
    </mat-paginator>
  </mat-card-actions>
</mat-card>
